import * as yup from "yup";
export const conceptSchema = yup.object().shape({
  brandingAsset: yup.string(),
  heading: yup.string(),
  subHeading: yup.string(),
  reference: yup.string(),
  ctaText: yup.string(),
  subCtaText: yup.string(),
});
